/* LSD course "wow" components v1 (vanilla, no libraries).
   Presentation only: it moves and decorates existing page elements; it never
   rewrites page copy, prices or links. Driven by sections/lsd-course-wow.liquid.
   Runs after lsd-inner-v1.js and lsd-course-polish-v1.js (all deferred, in order). */
(function(){
  var root=document.querySelector('[data-lsd-wow]');
  if(!root) return;
  var doc=document.documentElement;
  var content=document.querySelector('[data-lsd-page-content]');
  var reduce=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO='IntersectionObserver' in window;
  function $$(sel,ctx){ if(!sel) return []; try{ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }catch(e){ return []; } }
  function first(sel,ctx){ var l=$$(sel,ctx); return l[0]||null; }
  function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;}
  var uid=0;

  /* 1. Move stats + step timeline into the story, after the opening / key facts. */
  function place(){
    if(!content) return;
    var parts=$$(':scope > .lsd-wow-stats, :scope > .lsd-wow-steps',root);
    if(!parts.length) return;
    var anchor=null;
    (root.getAttribute('data-insert-after')||'').split(',').some(function(s){ anchor=first(s.trim(),content); return !!anchor; });
    if(!anchor) return;
    var ref=anchor;
    parts.forEach(function(p){ ref.insertAdjacentElement('afterend',p); ref=p; });
    // The routes block is a sibling inside the opening's parent; make the strip full width there.
    root.classList.add('is-placed');
  }

  /* 2. Image slots attached to page elements. */
  function padVars(t){
    var set=function(){ var cs=getComputedStyle(t); ['Top','Right','Left'].forEach(function(k){ t.style.setProperty('--lsd-wow-p'+k.charAt(0).toLowerCase(),cs['padding'+k]); }); };
    set(); padTargets.push(set);
  }
  var padTargets=[];
  window.addEventListener('resize',function(){ padTargets.forEach(function(f){ f(); }); },{passive:true});
  function media(){
    $$('.lsd-wow-media-slots > .lsd-wow-media',root).forEach(function(fig){
      var target=content && first(fig.getAttribute('data-target'),content);
      if(!target) return;
      var layout=fig.getAttribute('data-layout');
      if(layout==='band'){
        target.classList.add('lsd-wow-band');
        target.style.setProperty('--lsd-wow-bg','url("'+fig.getAttribute('data-bg')+'")');
        target.style.setProperty('--lsd-wow-bg-sm','url("'+fig.getAttribute('data-bg-sm')+'")');
        target.style.setProperty('--lsd-wow-focus',fig.style.getPropertyValue('--lsd-wow-focus')||'center');
        return;
      }
      fig.removeAttribute('data-target');
      if(layout==='split'){
        target.classList.add('lsd-wow-split');
        var body=el('div','lsd-wow-split__body');
        while(target.firstChild) body.appendChild(target.firstChild);
        target.appendChild(fig); target.appendChild(body);
      } else {
        target.classList.add('lsd-wow-has-cardtop');
        target.insertBefore(fig,target.firstChild);
        padVars(target);
      }
    });
    // Alternate split blocks left/right.
    $$('.lsd-wow-split',content).forEach(function(s,i){ s.classList.toggle('lsd-wow-split--flip',i%2===1); });
  }

  /* 3. "Read more": keep the first paragraph, short notes and anything with a link or
        button visible; fold the remaining paragraphs behind a toggle (nothing removed). */
  function readmore(){
    $$(root.getAttribute('data-readmore'),content).forEach(function(card){
      var host=card.querySelector(':scope > .lsd-wow-split__body')||card;
      var ps=$$(':scope > p',host);
      if(ps.length<3) return;
      var keep=function(p,i){
        if(i===0) return true;
        if(p.querySelector('a,button')) return true;
        var t=p.textContent.replace(/\s+/g,' ').trim(), s=p.querySelector(':scope > strong');
        return !!(s && s.textContent.replace(/\s+/g,' ').trim()===t); // a bold one-line note
      };
      // Group consecutive foldable paragraphs.
      var groups=[],cur=null;
      ps.forEach(function(p,i){
        if(keep(p,i)){ cur=null; return; }
        if(!cur || cur.last.nextElementSibling!==p){ cur={items:[]}; groups.push(cur); }
        cur.items.push(p); cur.last=p;
      });
      groups.forEach(function(g){ fold(g.items); });
    });
    // Long lists (e.g. "Important Information"): keep the first items visible, fold the rest.
    var lsel=root.getAttribute('data-readmore-list'), keepN=parseInt(root.getAttribute('data-readmore-keep'),10)||4;
    $$(lsel,content).forEach(function(card){
      $$('ul, ol, .lsd-course-route-list',card).forEach(function(list){
        if(list.closest('.lsd-wow-more')) return;
        var lis=$$(':scope > li',list);
        if(lis.length < keepN+3) return; // only worth folding when 3+ items would be hidden
        fold(lis.slice(keepN));
      });
    });
  }

  function fold(items){
    var id='lsd-wow-more-'+(++uid);
    var wrap=el('div','lsd-wow-more'); wrap.id=id;
    items[0].parentNode.insertBefore(wrap,items[0]);
    items.forEach(function(p){ wrap.appendChild(p); });
    var btn=el('button','lsd-wow-more__toggle');
    btn.type='button';
    btn.setAttribute('aria-expanded','false');
    btn.setAttribute('aria-controls',id);
    btn.appendChild(el('span','lsd-wow-more__label','Read more'));
    wrap.insertAdjacentElement('afterend',btn);
    wrap.setAttribute('data-collapsed','');
    btn.addEventListener('click',function(){
      var open=btn.getAttribute('aria-expanded')!=='true';
      btn.setAttribute('aria-expanded',open?'true':'false');
      btn.firstChild.textContent=open?'Show less':'Read more';
      if(open){ wrap.removeAttribute('data-collapsed'); wrap.style.maxHeight=wrap.scrollHeight+'px'; }
      else { wrap.style.maxHeight=wrap.scrollHeight+'px'; void wrap.offsetHeight; wrap.style.maxHeight=''; wrap.setAttribute('data-collapsed',''); }
    });
    wrap.addEventListener('transitionend',function(){ if(btn.getAttribute('aria-expanded')==='true') wrap.style.maxHeight='none'; });
    // If the browser's find-in-page or a #link lands inside, open it.
    wrap.addEventListener('focusin',function(){ if(btn.getAttribute('aria-expanded')!=='true') btn.click(); });
  }

  /* 4. Fade/slide in on scroll. */
  function reveal(){
    var items=$$(root.getAttribute('data-reveal'),content).concat($$('.lsd-wow-stats, .lsd-wow-steps__intro, .lsd-wow-step',content));
    if(reduce || !hasIO){ return; }
    items.forEach(function(n){
      if(n.getBoundingClientRect().top < window.innerHeight*0.9) return; // already on screen: leave as is
      n.classList.add('lsd-wow-reveal');
      var sib=n.parentNode ? Array.prototype.indexOf.call(n.parentNode.children,n) : 0;
      n.style.setProperty('--lsd-wow-delay',Math.min(sib,4)*90+'ms');
    });
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    $$('.lsd-wow-reveal',content).forEach(function(n){ io.observe(n); });
  }

  /* 5. Count-up stats (numbers come from the section's stat blocks). */
  function countup(){
    var nums=$$('.lsd-wow-stat__num[data-count]',content||root);
    if(reduce || !hasIO) return;
    nums.forEach(function(n){
      var raw=n.getAttribute('data-count'), end=parseFloat(raw);
      if(!isFinite(end) || !/^\d+(\.\d+)?$/.test(raw)) return;
      var dec=(raw.split('.')[1]||'').length;
      n.style.minWidth=n.getBoundingClientRect().width+'px';
      n.textContent=(0).toFixed(dec);
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(!e.isIntersecting) return; io.disconnect();
          var t0=null,dur=1400;
          function step(t){ if(!t0)t0=t; var p=Math.min(1,(t-t0)/dur), v=end*(1-Math.pow(1-p,3));
            n.textContent=p<1 ? v.toFixed(dec) : raw; if(p<1) requestAnimationFrame(step); }
          requestAnimationFrame(step);
        });
      },{threshold:0.4});
      io.observe(n);
    });
  }

  /* 6. Subtle parallax on photo bands (transform only, rAF-throttled, off for reduced motion). */
  function parallax(){
    if(reduce) return;
    var bands=$$(root.getAttribute('data-parallax'),content).concat($$('.lsd-wow-band',content));
    var layers=[];
    bands.forEach(function(b){
      if(b.querySelector(':scope > .lsd-wow-parallax')) return;
      var cs=getComputedStyle(b);
      var bg=b.classList.contains('lsd-wow-band') ? '' : cs.backgroundImage;
      var layer=el('div','lsd-wow-parallax'); layer.setAttribute('aria-hidden','true');
      if(bg && bg!=='none'){ layer.style.backgroundImage=bg; layer.style.backgroundPosition=cs.backgroundPosition; b.classList.add('lsd-wow-parallax-host'); }
      else if(!b.classList.contains('lsd-wow-band')) return;
      b.insertBefore(layer,b.firstChild);
      layers.push({host:b,layer:layer});
    });
    if(!layers.length) return;
    var ticking=false;
    function update(){
      ticking=false;
      var vh=window.innerHeight;
      layers.forEach(function(l){
        var r=l.host.getBoundingClientRect();
        if(r.bottom<-50 || r.top>vh+50) return;
        var p=(r.top+r.height/2-vh/2)/(vh/2+r.height/2); // -1..1
        l.layer.style.transform='translate3d(0,'+(p*-30).toFixed(1)+'px,0)';
      });
    }
    window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } },{passive:true});
    window.addEventListener('resize',update);
    update();
  }

  /* 7. Line up route group headers when the route panels sit side by side. */
  function equalise(){
    var heads=$$('.lsd-course-routes > .lsd-course-route-group > .lsd-course-route-group__header',content);
    if(heads.length<2) return;
    function run(){
      heads.forEach(function(h){ h.style.minHeight=''; });
      var tops=heads.map(function(h){ return Math.round(h.getBoundingClientRect().top); });
      if(tops.some(function(t){ return Math.abs(t-tops[0])>2; })) return; // stacked: leave natural heights
      var m=Math.max.apply(null,heads.map(function(h){ return h.getBoundingClientRect().height; }));
      heads.forEach(function(h){ h.style.minHeight=Math.ceil(m)+'px'; });
    }
    run(); var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(run,120); });
    if(document.fonts && document.fonts.ready) document.fonts.ready.then(run);
  }

  function init(){
    place(); media(); readmore(); equalise(); reveal(); countup(); parallax();
    doc.classList.add('lsd-wow-ready');
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
}());

/* v1.7: on phones, tuck the sticky booking bar away while scrolling down so it never sits over the content being read; bring it back on scroll up. */
(function(){
  var mq=window.matchMedia&&window.matchMedia('(max-width:760px)'); if(!mq) return;
  var last=window.pageYOffset||0;
  window.addEventListener('scroll',function(){
    var b=document.querySelector('.lsd-course-bookbar'); var y=window.pageYOffset||0;
    if(!b||!mq.matches){ last=y; return; }
    var nearEnd=(window.innerHeight+y)>=(document.documentElement.scrollHeight-40);
    if(y>last+6 && !nearEnd) b.classList.add('is-tucked'); else if(y<last-6 || nearEnd) b.classList.remove('is-tucked');
    last=y;
  },{passive:true});
}());
